module.exports = __webpack_public_path__ + "img/default-img.2a08d92c.png";